import { withIcon } from "../Icon"

export const IconFilter = withIcon(
  '<path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M4 7h16M6.667 12h10.666m-8 5h5.334"/>',
)
